import { ChangeEventHandler, FC, useEffect, useRef, useState } from 'react';
import { AddPhotoButtonText, HiddenImageInput, Image } from './views';
import styles from './ImageInput.module.css';
import PlusIcon from '../../../assets/icons/plus.svg?react';
import { MAX_FILES } from './constants';

export interface ImageInputProps {
  onChange: (files: File[]) => void;
}

export const ImageInput: FC<ImageInputProps> = ({ onChange }) => {
  const [files, setFiles] = useState<File[]>([]);

  const addMoreRef = useRef<HTMLLabelElement>(null);
  const prevCount = useRef<number>(files.length);

  useEffect(() => {
    if (prevCount.current !== files.length) {
      onChange(files);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files.length]);

  useEffect(() => {
    if (prevCount.current < files.length) {
      addMoreRef.current?.scrollIntoView?.();
    }
    prevCount.current = files.length;
  }, [files.length]);

  const add: ChangeEventHandler<HTMLInputElement> = (e) =>
    setFiles(
      [...files, ...Array.from(e.target.files!)].filter(
        (_, idx) => idx < MAX_FILES
      )
    );

  const del = (position: number) => () =>
    setFiles(files.filter((_, idx) => idx !== position));

  return (
    <>
      {files.length > 0 && (
        <div className={styles.galleryContainer}>
          <div className={styles.gallery}>
            {files.map((file, idx) => (
              <Image key={idx} file={file} onClose={del(idx)} />
            ))}
            {files.length < MAX_FILES && (
              <label ref={addMoreRef} className={styles.addAnotherPhoto}>
                <HiddenImageInput onChange={add} />
                <PlusIcon className={styles.plus} />
              </label>
            )}
          </div>
        </div>
      )}
      {!files.length && (
        <AddPhotoButtonText>
          <HiddenImageInput onChange={add} />
        </AddPhotoButtonText>
      )}
    </>
  );
};
